import * as React from "react";

const SvgComponent = ({ color = "#000", ...props }) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 0A7.507 7.507 0 0 0 0 7.5C0 11.637 3.363 15 7.5 15c4.137 0 7.5-3.363 7.5-7.5C15 3.363 11.637 0 7.5 0Zm3.221 8.447H8.447v2.274a.95.95 0 0 1-.947.947.95.95 0 0 1-.947-.947V8.447H4.279a.95.95 0 0 1-.947-.947.95.95 0 0 1 .947-.947h2.274V4.279A.95.95 0 0 1 7.5 3.33a.95.95 0 0 1 .947.948v2.274h2.274a.95.95 0 0 1 .948.947.95.95 0 0 1-.948.947Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;